import Model from '../model';





export default Model.extend( {

    endpoint: 'scripts?apiVersion=2.0',

    defaults() {
        return {
            title: '',
            description: '',
            on: true,
            cluster: null,
            webhook_server: undefined,
            script: 'return valid()',
            workgroups: [],
            types: [],
            priorities: [],
            roles: [],
            statuses_before: [],
            statuses_after: [],
            stages_before: [],
            stages_after: [],
            user_organizations_before: [], 
            user_organizations_after: [],
            user_roles_before: [],
            user_roles_after: [],
            user_types_before: [],
            user_types_after: [],
            user_tags_before: [],
            user_tags_after: [],

            operation: 'INSERT',
            type: 'VALIDATION',
            entity_type: 'TASK',
        };
    },

    computeds: {

        stages_before_: {

            get() {
                return this.get( 'stages_before' )
                    .map( value => ({ id: value, }) );
            },

            set(value) {
                return {
                    stages_before: value.map( item => item.id ),
                };
            },

        },

        stages_after_: {

            get() {
                return this.get( 'stages_after' )
                    .map( value => ({ id: value, }) );
            },

            set(value) {
                return {
                    stages_after: value.map( item => item.id ),
                };
            },

        },

    }

} );


// WEBPACK FOOTER //
// ./src/js/model/refbooks/script.js